import { render, staticRenderFns } from "./DRHome.vue?vue&type=template&id=5d5a9058&"
import script from "./DRHome.vue?vue&type=script&lang=js&"
export * from "./DRHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports